<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.infraestruturas.filter(infraestrutura => infraestrutura.deleted === false)"
        >
            <template v-slot:cell(enviaWhatsapp)="{item}">
                <rkm-form-checkbox v-model="item.enviaWhatsapp" />
            </template>

            <template v-slot:cell(faturaProcedimentoRaas)="{item}">
                <rkm-form-checkbox v-model="item.faturaProcedimentoRaas" />
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.ModalAssinatura.open(item)"
                    small
                    title="Configuração de assinatura eletrônica"
                >
                    <rkm-icon icon="signature" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalOcupacao.open(item)"
                    color="success"
                    small
                    title="Configuração de CBO"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEspecialidade.open(item)"
                    color="warning"
                    small
                    title="Configuração de especialidade"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalLocalAtendimentoAgendador.open(item)"
                    color="dark"
                    small
                    title="Local de atendimento agendador"
                >
                    <rkm-icon icon="building" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalServico.open(item)"
                    color="info"
                    small
                    title="Serviço"
                >
                    <rkm-icon icon="stream" />
                </rkm-button>

                <rkm-button
                    v-if="data.whatsappAgendamentoAtivo"
                    @click="$refs.ModalWhatsapp.open(item)"
                    color="secondary"
                    small
                    title="Configuração de WhatsApp"
                >
                    <font-awesome-icon :icon="whatsappIcon" fixed-width />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalOcupacao
            :data="{form: data.form}"
            ref="ModalOcupacao"
        />

        <ModalAssinatura
            :data="{form: data.form}"
            ref="ModalAssinatura"
        />

        <ModalEspecialidade ref="ModalEspecialidade" />

        <ModalLocalAtendimentoAgendador
            :data="{form: data.form}"
            ref="ModalLocalAtendimentoAgendador"
        />

        <ModalServico
            :data="{form: data.form}"
            ref="ModalServico"
        />

        <ModalWhatsapp ref="ModalWhatsapp" />
    </div>
</template>

<script>
// Components.
import ModalEspecialidade from './components/especialidade/Modal'
import ModalLocalAtendimentoAgendador from './components/local-atendimento-agendador/Modal'
import ModalAssinatura from './components/assinatura/Modal'
import ModalOcupacao from './components/ocupacao/Modal'
import ModalServico from './components/servico/Modal'
import ModalWhatsapp from './components/whatsapp/Modal'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons'

export default {
    components: {
        ModalEspecialidade,
        ModalLocalAtendimentoAgendador,
        ModalOcupacao,
        ModalAssinatura,
        ModalServico,
        ModalWhatsapp,
        FontAwesomeIcon,
    },
    data: () => ({whatsappIcon: faWhatsapp}),
    computed: {
        fields() {
            return [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'nome', label: 'Local de atendimento', sortable: true},
                ...(this.data.whatsappAgendamentoAtivo
                    ? [{key: 'enviaWhatsapp', label: 'Envia WhatsApp'}]
                    : []),
                {key: 'faturaProcedimentoRaas', label: 'Fatura procedimento RAAS'},
                {key: 'actions', label: 'Ações', class: 'col-min text-center'},
            ]
        },
    },
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o local de atendimento?', async () => {
                this.data.model.infraestruturas[index].deleted = true
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
